import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Loader2 } from 'lucide-react'
import type { PasoFormulario, PasoCreatePayload } from '../../types'

interface PasoDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (data: PasoCreatePayload) => void
  isSubmitting: boolean
  paso?: PasoFormulario | null
}

export function PasoDialog({ open, onOpenChange, onSubmit, isSubmitting, paso }: PasoDialogProps) {
  const { register, handleSubmit, reset, formState: { errors } } = useForm<PasoCreatePayload>({
    defaultValues: { titulo: '', descripcion: '' },
  })

  useEffect(() => {
    if (open) {
      reset(paso ? { titulo: paso.titulo, descripcion: paso.descripcion } : { titulo: '', descripcion: '' })
    }
  }, [open, paso, reset])

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[450px]">
        <DialogHeader>
          <DialogTitle>{paso ? 'Editar Paso' : 'Nuevo Paso'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="space-y-2">
            <Label>Título *</Label>
            <Input {...register('titulo', { required: 'Requerido' })} placeholder="Título del paso" />
            {errors.titulo && <p className="text-sm text-destructive">{errors.titulo.message}</p>}
          </div>
          <div className="space-y-2">
            <Label>Descripción</Label>
            <Textarea {...register('descripcion')} placeholder="Descripción opcional" rows={3} />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" disabled={isSubmitting} className="bg-teal-800 hover:bg-teal-900 text-white">
              {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {paso ? 'Guardar' : 'Crear'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
